// extracted by mini-css-extract-plugin
module.exports = {"smallScreen":"320px","mediumScreen":"768px","makerWhite":"#f3f3f6","q":"question_q__21bC7"};